import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { quickMessageApi } from "./api";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { toast } from "@shared/hooks/use-toast";

export const useSendDirectMessage = () => {
  return useSmartMutation(
    (payload: any) => quickMessageApi.sendDirectMessage(payload),
    {
      onSuccess: () => {
        toast({
          title: "Message Sent",
          description: "Your message was delivered successfully.",
        });
      },}
  );
};
export const useSendBulkNotification = () => {
  return useSmartMutation(
    (payload: any) => quickMessageApi.sendBulkNotification(payload),
     {
      onSuccess: () => {
        toast({
          title: "Notifications Sent",
          description: "Bulk notification sent ",
        });
      },}
  );
};

export const useRecipientList = (recipientType:any) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.quickMessage.recipientList(
recipientType
    ),
    () => quickMessageApi.getRecipientList(recipientType),
     {
      enabled: !!recipientType, 
    }
  );
};

export const useSearchConsumer = (
  searchTerm: string,
  remoteUtilityId: number
) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.quickMessage.searchConsumer(searchTerm, remoteUtilityId),

    () =>
      quickMessageApi.searchConsumer({
        remoteUtilityId,
        searchData: searchTerm,
      }),

    {
      enabled: searchTerm?.length >= 3,
      staleTime: 5 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
export const useUserInfoSearch = (
  searchTerm: string,
  remoteUtilityId?: number,
  page: number = 1,
  limit: number = 50
) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.quickMessage.userInfoSearch(
      searchTerm,
      remoteUtilityId,
      page,
      limit
    ),

    () =>
      quickMessageApi.getUserInfo({
        remoteUtilityId: remoteUtilityId!,
        page,
        limit,
        searchData: searchTerm,
      }),

    {
      enabled: !!searchTerm && searchTerm.length >= 2, // Auto run only when input valid
      retry: false,
    }
  );
};


export const useTemplateList = (audienceType:any) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.quickMessage.templatesList(audienceType),
    () => quickMessageApi.getTemplateList(audienceType)
  );
};

export const useGetTemplateData = (templateId: any) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.quickMessage.templateData(templateId),
    () => quickMessageApi.getTemplateData(templateId),
    {
      enabled: !!templateId,
    }
  );
};